.bt{flex-shrink:0;}